import React, { useEffect, useRef } from "react";

const TradingViewTimelineWidget = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      feedMode: "all_symbols",
      isTransparent: false,
      displayMode: "regular",
      width: "100%",
      height: "100%",
      colorTheme: "dark",
      locale: "en",
    });

    if (containerRef.current) {
      containerRef.current.innerHTML = ""; // Clear any previous widget
      containerRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="tradingview-widget-container h-100" ref={containerRef}>
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
};

export default TradingViewTimelineWidget;
